<template>
    <div>
        <el-form :model="mapData" ref="filterData">
            <el-row>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                    <el-form-item class="map-form">
                        <el-select :placeholder="$t('Select Organization')" :disabled="disableOrganization" clearable v-model="organizationSlug" size="medium"
                            @change="getMapData()">
                            <el-option v-for="(item) in organizationList.data" :label="item.display_name" :key="item.slug"
                                :value="item.slug"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="map-pin">
                    <div v-for="(icon, key) in icons" :key="key">
                        <img :src="icon.icon" :alt="key"> {{ $t(key) }}
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="map-check">
                    <el-checkbox v-model="showFachstellen" @change="getMapData()">{{ $t('Fachstellen') }}</el-checkbox>
                    <el-checkbox v-model="showClubs" @change="getMapData()">{{ $t('Clubs') }}</el-checkbox>
                </el-col>
            </el-row>
        </el-form>
        <div id="myMap" style="min-width: 250px; widht: 100%; min-height: 380px; height:100%"></div>
    </div>
</template>
<style scoped>
    .el-checkbox+.el-checkbox {
        margin-left: 0;
    }
    .el-form-item{
        margin-bottom: 15px;
    }
</style>

<script>
    export default {
        props: {
            organizationList: Object
        },
        mounted() {
            // this.initMap();
            this.getMapData();
            if(this.$store.state.config.user.organization_slug) {
                this.disableOrganization = true;
            }
        },
        methods: {
            initMap() {
                this.map = new google.maps.Map(document.getElementById('myMap'), {
                    center: {
                        lat: 46.8182,
                        lng: 8.2275
                    },
                    zoom: 7
                });
                this.geocoder = new google.maps.Geocoder();
                this.bounds = new google.maps.LatLngBounds();
                this.infowindow = new google.maps.InfoWindow();
                this.createMarker();
            },
            createMarker() {
                var location_found = 0;
                this.locations.forEach(function (location) {
                    if(location.latitude && location.longitude){
                        location_found++;
                        var position = new google.maps.LatLng(location.latitude, location.longitude);
                        var marker = new google.maps.Marker({
                            position: position,
                            icon: this.icons[location.type].icon,
                            map: this.map
                        });

                        var contentString = '<strong>' + location.name + '</strong><br>' + location.address;
                        google.maps.event.addListener(marker, 'click', function () {
                            this.infowindow.setContent(contentString);
                            this.infowindow.open(this.map, marker);
                        }.bind(this));
                        this.bounds.extend(marker.position);
                    }
                }.bind(this));
                if(location_found) {
                    setTimeout(this.map.fitBounds(this.bounds), 5000);
                }
            },
            getMapData() {
                request({
                    url: "get-organisation-wise-fachstellen-clubs",
                    method: "get",
                    params: {
                        organizationSlug: this.organizationSlug,
                        showClubs: this.showClubs,
                        showFachstellen: this.showFachstellen
                    }
                }).then(response => {
                    this.locations = response.data.data;
                    this.initMap();
                });
            }
        },
        data() {
            return {
                geocoder: {},
                mapData: {},
                map: null,
                bounds: null,
                nextAddress: 0,
                delay: 100,
                infowindow: null,
                locations: {},
                icons: {
                    Fachstellen: {
                        icon: '/static/map-pin-green-24.png'
                    },
                    Club: {
                        icon: '/static/map-pin-blue-24.png'
                    }
                },
                organizationSlug: (this.$store.state.config.user.organization_slug) ? this.$store.state.config.user.organization_slug : null,
                showFachstellen: true,
                showClubs: true,
                disableOrganization: false
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Layout/Widgets/chart/components/OrganizationWiseFachstellenAndClubs.vue